*:focus {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

*:focus:not(:focus-visible) {
	outline: none;
}

*:focus-visible {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

.hidden {
	display: none;
}

.invisible {
	visibility: hidden;
}

.offscreen {
	position: absolute;
	left: -1000em;
}

.screen-reader-text {
	position: absolute;

	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;

	border: 0;
	clip-path: inset(50%);

	white-space: nowrap;
}

.screen-reader-text--focusable:active,
.screen-reader-text--focusable:focus {
	position: relative;

	width: auto;
	height: auto;
	margin: 0;
	overflow: visible;

	clip-path: none;

	white-space: inherit;
}

/** @deprecated */
/** ".is-tabbing" should be added via JavaScript and shows the outline. Used with class to not show outline on clicking elements. */
.is-tabbing button::-moz-focus-inner,
:host(.is-tabbing) button::-moz-focus-inner {
	border: 0;
}

.is-tabbing--focus,
.is-tabbing a:focus,
.is-tabbing button:focus,
.is-tabbing div:focus,
.is-tabbing input:focus,
.is-tabbing input:focus ~ span[role="presentation"],
:host(.is-tabbing) a:focus,
:host(.is-tabbing) button:focus,
:host(.is-tabbing) div:focus,
:host(.is-tabbing) input:focus,
:host(.is-tabbing) input:focus ~ span[role="presentation"] {
	outline: 2px dotted #e2002a;
	outline-offset: 2px;
	z-index: 10;
}


:host {
	display: none;
	position: absolute;
	top: 30px;
	left: 0;
	width: 296px;
	min-height: 200px;
	background: #fbfbfb;
	z-index: 2;
	box-sizing: border-box;

	overflow:hidden;
	padding:0;
	white-space: normal;
}

.calendar{
	box-sizing: border-box;
	border:1px solid #999;
}

.calendar:focus{
	border:1px solid #000;
	outline:0;
}

.fields-panel{
	min-height: 100px;
	background: #fff;
	box-sizing: border-box;
}

h3 {
	text-align: center;
	font-size: 22px;
	padding-top: 12px;
	padding-bottom: 12px;
	margin: 0;
	background: #e0e0e0;
}

th {
	text-align: center;
	min-width: 42px;
	border: 0;
	margin: 0;
	background-color: #d7d7d7;
}

​td {
	text-align: center;
	border: 0;
	margin: 0;
	padding: 0;
}

.calendar button.focus:focusring{
   outline:0;
}

.calendar-header {
	position: relative;
	box-sizing: border-box;
}

.calendar-header button {
	display: inline-block;
	position: absolute;
	top: 50%;
	margin-top: -16px;
	border: none;
	background: transparent;
	padding: 6px 12px;
	cursor: pointer;
	outline:0;
}

.not-in-month,
.disabled {
	opacity:0.4;
}

.calendar-header button:active,
.calendar-header button:focus,
.calendar-header button:hover {
	outline: 0;
	fill: var(--oebb-accent-color, #e2002a);
}

.calendar-header button:disabled {
	opacity: 0.4;
	cursor: not-allowed;
	fill: #000000;
}

.calendar-header button:active {
	padding: 7px 11px 5px 13px;
}

.calendar-header button.next-btn {
	right: 0;
}

.calendar-header button.previous-btn {
	left: 0;
}

.main-content .calendar ul,
ul {
	margin: 0;
	padding: 0;
	list-style-type: none;
	width: 294px;
	position: relative;
	box-sizing: border-box;
}

ul.header {
	height: 42px;
	box-sizing: border-box;
	overflow: hidden;
}

.main-content .calendar li,
li {
	display: inline-block;
	font-size: 20px;
	width: 42px;
	height: 42px;
	position: relative;
}

li button {
	display: inline-block;
	text-align: center;
	width: 42px;
	height: 42px;
	line-height: 42px;
	box-sizing: border-box;
	background: white;
	border: 1px solid #fff;
}

ul.header li {
	background: #cccccc;
	border: 1px solid #cccccc;
	display: inline-block;
	text-align: center;
	width: 42px;
	height: 42px;
	line-height: 42px;
	box-sizing: border-box;
	color: #000;
	overflow: hidden;
}

ul.days {
	background: #ffffff;
}

li.dow-2:first-child {
	margin-left: 42px;
}

li.dow-3:first-child {
	margin-left: 84px;
}

li.dow-4:first-child {
	margin-left: 126px;
}

li.dow-5:first-child {
	margin-left: 168px;
}

li.dow-6:first-child {
	margin-left: 210px;
}

li.dow-0:first-child {
	margin-left: 252px;
}

li.dow-0 button {
	color: #e2002a;
}

li button.today {
	border: 1px solid #cccccc;
	font-weight: bold;
}

.days li button {
	cursor: pointer;
	font-size: 16px;
}

.days button:focus,
.days button.focused,
.days button:hover {
	background-color: #e0e0e0;
	border: 1px solid #e0e0e0;
	outline: 0;
}

.days button:active {
	outline:0;
}

li button.active {
	color: var(--oebb-accent-color, #e2002a);
	background-color: #fff;
	border: 1px solid var(--oebb-accent-color, #e2002a);
}

.days button.active:focus {
	color: var(--oebb-accent-color, #e2002a);
	background-color: #fff;
	border: 1px solid var(--oebb-accent-color, #e2002a);
}

.days button.active:hover {
	color: #fff;
	background-color: var(--oebb-accent-color, #e2002a);
	border: 1px solid var(--oebb-accent-color, #e2002a);
}

.days button:disabled {
	cursor: not-allowed;
}

.calendar-footer {
	background: #e0e0e0;
	box-sizing: border-box;
}

button.footer-btn {
	border: none;
	background: transparent;
	position: relative;
	padding: 6px;
	text-transform: uppercase;
	width:auto;
}

button.footer-btn:focus,
button.footer-btn:hover {
	text-decoration: underline;
	outline: 0;
}

button.footer-btn:active {
	padding: 7px 5px 5px 7px;
}

.calendar-header .calendar__close-btn {
	position: absolute;
	top: -0.5rem;
	right: 1.25rem;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 1.875rem;
	height: 1.875rem;
	background-color: #ffffff;
	border-radius: 50%;
	opacity: 0;
}

.calendar-header .calendar__close-btn:focus {
	opacity: 1;
}